import { render } from "./PackageCard.vue?vue&type=template&id=1d0373a8&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"

import "./PackageCard.vue?vue&type=style&index=0&id=1d0373a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0373a8"]])

export default __exports__